interface cardData {
  imgSrc: string;
  name: string;
  type: string;
  url: string;
  absPath?: boolean;
  newTab?: boolean;
}

function Card({
  imgSrc,
  name,
  type,
  url,
  absPath = false,
  newTab = false,
}: cardData) {
  const navigateTo = () => {
    if (newTab) {
      window.open(url, "_blank");
    } else if (absPath) {
      window.location.assign(url);
    } else {
      window.location.href = `/${url}`;
    }
  };

  const tags = type.split(",").map((tag) => tag.trim());

  return (
    <article className="card" onClick={navigateTo}>
      <div className="image-cont">
        <img src={imgSrc} alt={name} />
      </div>
      <div className="card-data">
        <div className="card-meta">
          {tags.map((tag) => (
            <span className="chip" key={tag}>
              {tag}
            </span>
          ))}
        </div>
        <h3>{name}</h3>
        <button type="button">
          View build <span>→</span>
        </button>
      </div>
    </article>
  );
}

export default Card;
